/**
 * Given a string to use when filtering localized sites, sanitize
 * and normalize it.
 *
 * @param filterString - String to normalize.
 * @returns The normalized string.
 */
export const normalizeFilterString = (filterString: string): string => {
  return filterString
    .toLowerCase() // Lowercase the entire string
    .replaceAll(/[^A-Za-z]/g, ''); // Remove any non-letter chars
};
